/**
 * The legal texts in Turkish (docs/LEGAL.md). The English ones in `en.ts` say the same, section
 * for section: change both together, and bump `LEGAL_VERSION` (documents.ts).
 */

import type { LegalTexts } from '../documents';

export const TR_TEXTS: LegalTexts = {
  updated: '29 Ekim 2026',
  documents: {
    terms: {
      title: 'Kullanım Şartları',
      summary:
        'QuantPhi’yi kullanırken geçerli kurallar: hizmetin ne olduğu ve ne olmadığı, hesabınız, borsa anahtarlarınız, paketler ve sorumluluk.',
      sections: [
        {
          id: 'scope',
          heading: '1. Taraflar ve kapsam',
          blocks: [
            'Bu Kullanım Şartları (“Şartlar”), quantphi.app adresindeki web sitesi ve uygulama, Telegram botu ve bunlara bağlı diğer arayüzlerin (birlikte “QuantPhi” veya “Hizmet”) kullanımını düzenler. Hizmet’i quantphi.app üzerinden QuantPhi (“biz”) sunar; iletişim bilgilerimiz {privacy:’nde} yer alır.',
            'Hesap oluşturduğunuzda bu Şartları ve {risk:’ni} okuduğunuzu ve kabul ettiğinizi beyan edersiniz; kişisel verilerinizin nasıl işlendiği {privacy:’nde} anlatılır. Kabul etmiyorsanız Hizmet’i kullanmayın.',
          ],
        },
        {
          id: 'tool',
          heading: '2. Hizmet bir yazılım aracıdır',
          blocks: [
            'QuantPhi, kripto varlık alım-satım emirlerini sizin belirlediğiniz kurallarla, sizin borsa hesabınızda otomatik olarak veren bir yazılımdır. DCA, grid, rebalance, düzenli alım ve Hedge Stop botlarını; otopilot, piyasa tarayıcısı, backtest ve vitrin özelliklerini içerir.',
            [
              'QuantPhi bir borsa, aracı kurum, kripto varlık hizmet sağlayıcısı, portföy yöneticisi veya yatırım danışmanı değildir.',
              'Paranızı veya kripto varlıklarınızı saklamaz, kabul etmez, transfer etmez ve çekmez. Varlıklarınız her zaman kendi borsa hesabınızda kalır.',
              'Emirler, bağladığınız borsa hesabında, sizin API anahtarınızla ve sizin yaptığınız ya da onayladığınız ayarlarla verilir.',
              'Bir botu, otopilotu veya önerilen bir ayarı başlatma, değiştirme ve durdurma kararı yalnızca size aittir.',
            ],
          ],
        },
        {
          id: 'advice',
          heading: '3. Yatırım tavsiyesi değildir',
          blocks: [
            'Sitede, uygulamada, Telegram’da ve sosyal medya hesaplarımızda yer alan içerikler — piyasa tarayıcısının önerileri, otopilotun seçimleri, vitrin ve sonuç kartları, backtest sonuçları ve varsayılan ayarlar dahil — 6362 sayılı Sermaye Piyasası Kanunu ve ilgili mevzuat kapsamında yatırım danışmanlığı, yatırım tavsiyesi veya alım-satım önerisi değildir.',
            'Bu içerikler, yazılımın geçmiş fiyat verileri ve seçilen ayarlar üzerinde yaptığı mekanik hesapların sonuçlarıdır. Mali durumunuz, risk ve getiri tercihleriniz dikkate alınmadan üretilir; bu nedenle sizin için uygun olmayabilir. Yatırım danışmanlığı hizmeti, yetkili kuruluşlarla imzalanacak yatırım danışmanlığı sözleşmesi çerçevesinde sunulur.',
            'Geçmiş sonuçlar ve backtestler gelecekteki getirinin garantisi değildir. Hiçbir paket, bot veya ayar kâr garantisi vermez.',
          ],
        },
        {
          id: 'account',
          heading: '4. Hesap ve uygunluk',
          blocks: [
            [
              '18 yaşını doldurmuş ve ehliyetli olmalısınız. Bulunduğunuz ülkenin mevzuatı kripto varlık alım-satımını veya bu tür yazılımların kullanımını yasaklıyorsa Hizmet’i kullanmayın.',
              'Kayıt bilgilerinizin doğru ve güncel olmasından, şifrenizin gizliliğinden ve hesabınızda yapılan işlemlerden siz sorumlusunuz.',
              'Hesabınızda yetkisiz bir kullanım fark ederseniz hemen {email} adresine bildirin.',
              'Hesabınızı başkasına devredemez, satamaz veya kiralayamazsınız.',
            ],
          ],
        },
        {
          id: 'keys',
          heading: '5. Borsa hesabınız ve API anahtarlarınız',
          blocks: [
            [
              'Borsa hesabınız ve içindeki varlıklar size aittir. Borsayla ilişkiniz o borsanın kendi kullanım koşullarına tabidir; bunlara uymak sizin sorumluluğunuzdadır.',
              'API anahtarlarınızı yalnızca okuma ve işlem izniyle oluşturun; çekim (withdrawal) iznini asla açmayın. QuantPhi çekim yapmaz ve çekim izni isteyen bir özelliği yoktur.',
              'Anahtarlarınız sunucularımızda şifrelenmiş olarak saklanır. Bir anahtarı borsanızdan istediğiniz an iptal edebilir veya uygulamadan silebilirsiniz. Anahtarı silmek, borsada açık kalan emirleri ve pozisyonları kapatmaz.',
              'Borsa kesintileri, emir retleri, fiyat kayması, likidite eksikliği, fonlama ücretleri, tasfiye (likidasyon), hesap kısıtlamaları, listeden çıkarma veya borsanın iflası gibi borsadan kaynaklanan olaylar QuantPhi’nin kontrolü dışındadır.',
            ],
          ],
        },
        {
          id: 'plans',
          heading: '6. Paketler ve ödemeler',
          blocks: [
            [
              'Hizmet’in bazı özellikleri ücretli paketlere bağlıdır. Paketlerin içeriği, süresi ve fiyatı sitede ve uygulamada gösterilir. Ödemeler USDT ile, uygulamada gösterilen ağ ve tutarla alınır.',
              'Deneme süreleri, kampanyalar ve indirim kodları duyurulan koşul ve sürelerle sınırlıdır. Bunları ileriye dönük olarak değiştirebilir veya sona erdirebiliriz; başlamış bir paket süresi bundan etkilenmez.',
              'Transferin doğru ağa, doğru adrese ve tam tutarla yapılmasını kontrol etmek sizin sorumluluğunuzdadır. Blokzincir transferleri geri alınamaz; yanlış ağa veya adrese gönderilen tutarı geri getiremeyebiliriz.',
              'Paketler, ödeme onaylandığında elektronik ortamda hemen etkinleşir. Bu nedenle, yürürlükteki tüketici mevzuatından doğan haklarınız saklı kalmak kaydıyla, başlamış bir paket süresi için ücret iadesi yapılmaz.',
            ],
          ],
        },
        {
          id: 'rules',
          heading: '7. Kullanım kuralları',
          blocks: [
            'Aşağıdakiler yasaktır:',
            [
              'Hizmet’i hukuka aykırı amaçlarla, piyasa dolandırıcılığı veya fiyat manipülasyonu için kullanmak;',
              'size ait olmayan veya kullanma yetkiniz olmayan bir borsa hesabını bağlamak;',
              'sistemin güvenliğini aşmaya, yazılımı tersine mühendislikle çözmeye, Hizmet’e aşırı yük bindirmeye veya izinsiz otomatik veri toplamaya çalışmak;',
              'deneme, kampanya ve indirim haklarından birden fazla hesapla yararlanmak.',
            ],
            'Bu kurallara aykırılık halinde hesabınızı askıya alabilir veya kapatabiliriz.',
          ],
        },
        {
          id: 'showcase',
          heading: '8. Vitrin ve sonuçlar sayfası',
          blocks: [
            'Vitrin ve herkese açık sonuçlar sayfası, platformda çalışan botların sonuçlarını anonim olarak (rastgele bir adla, tutar ve tarih göstermeden, yüzde olarak) ve sistemin kendi yaptığı backtestleri gösterir. Yalnızca getirisi pozitif olan botlar gösterilir; bu nedenle kartlar platformdaki botların ortalama sonucunu yansıtmaz.',
            'Bir kartı kopyalamak, onun sonucunu kopyalamak demek değildir: aynı ayarlar sizin hesabınızda, sizin tutarlarınızla ve başka bir zamanda farklı sonuç verebilir ve zarar edebilir. Backtest kartları gerçek işlem değildir.',
          ],
        },
        {
          id: 'availability',
          heading: '9. Hizmetin sürekliliği',
          blocks: [
            'Hizmet “olduğu gibi” ve “mevcut olduğu ölçüde” sunulur; kesintisiz veya hatasız çalışacağını taahhüt etmeyiz. Sunucu, ağ, borsa API’si veya yazılım hataları nedeniyle botlar emir veremeyebilir, emirleri geç verebilir veya iptal edemeyebilir.',
            'Bakım ve güncelleme yapabilir, özellikleri değiştirebilir veya kaldırabiliriz. Hizmet durduğunda borsada açık olan emirler ve pozisyonlar borsada kalır; bunları borsanızdan izlemek sizin sorumluluğunuzdadır.',
          ],
        },
        {
          id: 'liability',
          heading: '10. Sorumluluğun sınırı',
          blocks: [
            'Yatırım kararlarınız ve sonuçları, borsa hesabınız ve API anahtarlarınız, bot ve otopilot ayarlarınız ile Hizmet’e girdiğiniz veriler tamamen sizin sorumluluğunuzdadır. QuantPhi ile verdiğiniz her emrin kârı da zararı da size aittir.',
            'Mevzuatın izin verdiği ölçüde QuantPhi; piyasa hareketlerinden, sizin yaptığınız veya onayladığınız ayarlardan, kaldıraç ve tasfiyeden, borsadan ve diğer üçüncü taraf hizmetlerden kaynaklanan olaylardan ve yazılımın beklenen şekilde çalışmamasından doğan doğrudan veya dolaylı zararlardan ve kâr kaybından sorumlu değildir.',
            'Her durumda toplam sorumluluğumuz, zararın doğduğu tarihten önceki 12 ayda bize ödediğiniz paket ücretlerinin toplamıyla sınırlıdır. Kast ve ağır ihmalden doğan sorumluluk ile tüketici mevzuatından doğan zorunlu haklarınız saklıdır.',
          ],
        },
        {
          id: 'ip',
          heading: '11. Fikri mülkiyet',
          blocks: [
            'Yazılım, tasarım, içerikler ile QuantPhi ve HopeBot adları ve logoları bize aittir. Size, Hizmet’i bu Şartlara uygun olarak kendi hesabınız için kullanmak üzere devredilemez ve münhasır olmayan bir kullanım hakkı tanınır.',
          ],
        },
        {
          id: 'closing',
          heading: '12. Hesabın kapatılması',
          blocks: [
            'Hesabınızın kapatılmasını istediğiniz zaman {email} adresinden isteyebilirsiniz. Hesap kapanırken botlarınız durdurulur; borsada açık kalan emirler ve pozisyonlar borsanızda kalır. Verilerinizin ne kadar saklandığı {privacy:’nde} yazılıdır.',
          ],
        },
        {
          id: 'changes',
          heading: '13. Değişiklikler',
          blocks: [
            'Bu Şartları güncelleyebiliriz; güncel sürüm ve tarihi bu sayfadadır. Önemli değişiklikleri sitede veya uygulamada duyurur, gerektiğinde onayınızı yeniden isteriz. Değişiklikten sonra Hizmet’i kullanmaya devam etmeniz güncel Şartları kabul ettiğiniz anlamına gelir.',
          ],
        },
        {
          id: 'law',
          heading: '14. Uygulanacak hukuk ve uyuşmazlıklar',
          blocks: [
            'Bu Şartlara Türk hukuku uygulanır. Uyuşmazlıklarda Türkiye mahkemeleri ve icra daireleri yetkilidir. Tüketici olarak hareket eden kullanıcıların tüketici hakem heyetlerine ve tüketici mahkemelerine başvurma hakkı saklıdır.',
          ],
        },
        {
          id: 'contact',
          heading: '15. İletişim',
          blocks: ['Sorularınız için: {email}'],
        },
      ],
    },

    privacy: {
      title: 'Gizlilik ve KVKK Aydınlatma Metni',
      summary:
        'Hangi kişisel verilerinizi, hangi amaçla ve hangi hukuki sebeple işlediğimiz, kimlere aktardığımız ve haklarınız. 6698 sayılı Kişisel Verilerin Korunması Kanunu (KVKK) madde 10 uyarınca hazırlanmıştır.',
      sections: [
        {
          id: 'controller',
          heading: '1. Veri sorumlusu',
          blocks: [
            'Kişisel verileriniz, veri sorumlusu sıfatıyla aşağıdaki kişi tarafından işlenir:',
            ['Unvan: QuantPhi', 'Web sitesi: quantphi.app', 'E-posta: {email}'],
          ],
        },
        {
          id: 'data',
          heading: '2. İşlediğimiz kişisel veriler',
          blocks: [
            [
              'Kimlik ve iletişim: e-posta adresiniz ve girerseniz adınız.',
              'Hesap güvenliği: şifrenizin geri çevrilemeyen özeti (şifrenin kendisi saklanmaz), oturum kayıtları, IP adresi ve tarayıcı bilgisi (user-agent).',
              'Borsa bağlantısı: borsa, bağlantıya verdiğiniz ad, API anahtarı ve gizli anahtar (şifrelenmiş olarak).',
              'İşlem verileri: botlarınız ve ayarları; emirler, işlemler, pozisyonlar, bakiyeler ve kâr/zarar — borsanızdan API anahtarınızla okunanlar dahil.',
              'Ödeme bilgileri: seçtiğiniz paket, tutar, ağ, işlem kimliği (TxID), ödeme etiketi, kupon ve kampanya. Kart bilgisi işlemeyiz.',
              'Kayıt kaynağı: siteye geldiğiniz bağlantının kampanya etiketleri (utm), referans ve kupon kodu.',
              'Telegram (bağlarsanız): Telegram kullanıcı kimliğiniz, kullanıcı adınız ve sohbet kimliği.',
              'Tercihler ve yazışmalar: dil, tema ve bildirim ayarlarınız; bize gönderdiğiniz e-postalar.',
            ],
          ],
        },
        {
          id: 'purposes',
          heading: '3. İşleme amaçları',
          blocks: [
            [
              'hesabınızı açmak ve yönetmek;',
              'botların, sizin kurduğunuz kurallarla borsa hesabınızda emir vermesini sağlamak; bakiye, pozisyon ve sonuçlarınızı göstermek;',
              'backtest, piyasa tarayıcısı, otopilot ve vitrin özelliklerini çalıştırmak;',
              'paketleri, ödemeleri, deneme sürelerini ve kampanyaları yürütmek, paket sonu hatırlatmaları göndermek;',
              'uygulama içi ve Telegram bildirimlerini göndermek, destek taleplerinize yanıt vermek;',
              'güvenliği sağlamak: yetkisiz erişimi ve kötüye kullanımı önlemek, giriş denemelerini sınırlamak;',
              'hangi bağlantıların kayıt getirdiğini ölçmek;',
              'hukuki yükümlülüklerimizi yerine getirmek ve olası uyuşmazlıklarda haklarımızı korumak.',
            ],
          ],
        },
        {
          id: 'grounds',
          heading: '4. Hukuki sebepler',
          blocks: [
            'Kişisel verilerinizi KVKK madde 5/2’deki şu sebeplere dayanarak işleriz:',
            [
              '(c) bir sözleşmenin kurulması veya ifasıyla doğrudan ilgili olması — {terms} kapsamındaki hizmetin sunulması;',
              '(ç) hukuki yükümlülüğümüzü yerine getirebilmek için zorunlu olması — örneğin ödeme kayıtlarının saklanması;',
              '(e) bir hakkın tesisi, kullanılması veya korunması için zorunlu olması;',
              '(f) temel hak ve özgürlüklerinize zarar vermemek kaydıyla meşru menfaatimiz için zorunlu olması — güvenlik kayıtları, kayıt kaynağının ölçülmesi ve anonim istatistikler.',
            ],
            'Bu sebeplerin dışında kalan bir işleme için ayrıca açık rızanızı isteriz.',
          ],
        },
        {
          id: 'collection',
          heading: '5. Toplama yöntemi',
          blocks: [
            'Verileriniz; kayıt ve uygulama içi formlar, bağladığınız borsanın API’si, Telegram botu ve e-posta yoluyla, ayrıca sunucu kayıtlarıyla otomatik olarak toplanır. USDT ödemeleriniz, QuantPhi’nin Binance hesabına gelen transferlerle eşleştirilir.',
            'Tarayıcınızın yerel depolamasında (localStorage) yalnızca Hizmet’in çalışması için gerekli bilgiler tutulur: oturum anahtarı, dil ve tema tercihi, bağlantıyla gelen kupon kodu ve kayıt kaynağı. Reklam veya analitik çerezi ve üçüncü taraf izleme aracı kullanmıyoruz.',
          ],
        },
        {
          id: 'transfer',
          heading: '6. Aktarım ve yurt dışı',
          blocks: [
            'Kişisel verilerinizi satmayız ve reklam amacıyla paylaşmayız. Yalnızca Hizmet’in sunulması için gerekli olduğu ölçüde şu alıcılara aktarırız:',
            [
              'Barındırma: Oracle Cloud Infrastructure. Sunucularımız ve veritabanımız Oracle’ın Frankfurt (Almanya) veri merkezindedir.',
              'Bağladığınız borsa (örneğin Bybit, OKX, Bitget, Binance): emirler ve okuma istekleri, sizin talimatınızla ve sizin API anahtarınızla borsanıza gönderilir. Borsaların kendi gizlilik politikaları geçerlidir.',
              'Telegram: bağlarsanız, bildirimlerin size iletilmesi için.',
              'Cloudflare (alan adı ve e-posta yönlendirme) ve Google (Gmail): {email} adresine yazdığınız e-postaların bize ulaşması için.',
              'Yetkili kamu kurum ve kuruluşları ile yargı mercileri: hukuken zorunlu olduğunda.',
            ],
            'Sunucularımız Almanya’da, yukarıdaki hizmet sağlayıcıların bir kısmı da Türkiye dışında bulunduğundan kişisel verileriniz yurt dışına aktarılır. Bu aktarım KVKK madde 9’daki şartlara uygun olarak yapılır. Borsanıza giden istekler ise sizin talimatınızla ve hizmetin ifası için gönderilir.',
          ],
        },
        {
          id: 'showcase',
          heading: '7. Vitrin ve anonim istatistikler',
          blocks: [
            'Platformda çalışan botların sonuçları, vitrinde ve herkese açık sonuçlar sayfasında anonim olarak gösterilebilir: rastgele üretilmiş bir ad, coin, borsa, strateji ayarları (tutarlar yerine oranlar), gün sayısı ve yüzde getiriler. Adınız, e-postanız, hesabınız, tutarlar, bot kimliği ve tarihler gösterilmez; kartlar size bağlanamayacak şekilde hazırlanır. Bu konudaki soru ve talepleriniz için {email} adresine yazabilirsiniz.',
          ],
        },
        {
          id: 'retention',
          heading: '8. Saklama süresi',
          blocks: [
            [
              'Hesap verileriniz hesabınız açık olduğu sürece saklanır.',
              'Bir borsa bağlantısını sildiğinizde, o bağlantının şifreli API anahtarları da silinir.',
              'Hesabınız kapatıldığında verileriniz, mevzuatın öngördüğü süreler (örneğin ödeme ve muhasebe kayıtları için vergi ve ticaret mevzuatındaki süreler) ve olası uyuşmazlıklar için zamanaşımı süreleri boyunca saklanır; ardından silinir, yok edilir veya anonim hale getirilir.',
            ],
          ],
        },
        {
          id: 'rights',
          heading: '9. KVKK madde 11 kapsamındaki haklarınız',
          blocks: [
            'Veri sorumlusuna başvurarak şu haklarınızı kullanabilirsiniz:',
            [
              'kişisel verilerinizin işlenip işlenmediğini öğrenmek;',
              'işlenmişse buna ilişkin bilgi talep etmek;',
              'işlenme amacını ve amacına uygun kullanılıp kullanılmadığını öğrenmek;',
              'yurt içinde veya yurt dışında aktarıldığı üçüncü kişileri bilmek;',
              'eksik veya yanlış işlenmişse düzeltilmesini istemek;',
              'KVKK madde 7’deki şartlar çerçevesinde silinmesini veya yok edilmesini istemek;',
              'düzeltme, silme ve yok etme işlemlerinin verilerin aktarıldığı üçüncü kişilere bildirilmesini istemek;',
              'münhasıran otomatik sistemlerle analiz edilmesi sonucunda aleyhinize bir sonucun ortaya çıkmasına itiraz etmek;',
              'kanuna aykırı işleme nedeniyle zarara uğramanız halinde zararın giderilmesini talep etmek.',
            ],
          ],
        },
        {
          id: 'apply',
          heading: '10. Başvuru',
          blocks: [
            'Başvurunuzu, sistemimizde kayıtlı e-posta adresinizden {email} adresine e-postayla ya da yazılı olarak veri sorumlusunun yukarıdaki adresine iletebilirsiniz. Başvurunuzda adınızı, hesabınızın e-posta adresini ve talebinizi açıkça belirtin.',
            'Başvurunuzu en geç 30 gün içinde ücretsiz olarak sonuçlandırırız. İşlemin ayrıca bir maliyet gerektirmesi halinde Kişisel Verileri Koruma Kurulu’nun belirlediği tarifedeki ücret alınabilir.',
          ],
        },
        {
          id: 'security',
          heading: '11. Güvenlik',
          blocks: [
            'API anahtarlarınızı şifreleyerek, şifrenizi tek yönlü özet olarak saklarız. Site ile aranızdaki bağlantı HTTPS (TLS) ile şifrelenir; sunuculara ve veritabanına erişim yetkili kişilerle sınırlıdır. Hiçbir sistem tamamen güvenli değildir: API anahtarlarınızı çekim izni olmadan oluşturmanız, olası bir sızıntının etkisini sınırlar.',
          ],
        },
        {
          id: 'children',
          heading: '12. Çocuklar',
          blocks: [
            'Hizmet 18 yaşından küçükler için değildir; onların verilerini bilerek işlemeyiz.',
          ],
        },
        {
          id: 'changes',
          heading: '13. Değişiklikler',
          blocks: [
            'Bu metni güncelleyebiliriz; güncel sürüm ve tarihi bu sayfadadır. Önemli değişiklikleri sitede veya uygulamada duyururuz.',
          ],
        },
      ],
    },

    risk: {
      title: 'Risk Bildirimi',
      summary:
        'Kripto varlık alım-satımı ve otomatik botlar ciddi riskler taşır. QuantPhi’yi kullanmadan önce bu metni okuyun.',
      sections: [
        {
          id: 'loss',
          heading: '1. Paranızın tamamını kaybedebilirsiniz',
          blocks: [
            'Kripto varlıkların fiyatları çok oynaktır; kısa sürede değerlerinin büyük kısmını veya tamamını kaybedebilirler. Yalnızca kaybetmeyi göze alabileceğiniz tutarlarla işlem yapın.',
          ],
        },
        {
          id: 'leverage',
          heading: '2. Kaldıraç ve vadeli işlemler',
          blocks: [
            'Kaldıraçlı vadeli işlemlerde küçük bir ters fiyat hareketi teminatınızın tamamını silebilir ve pozisyonunuz borsa tarafından tasfiye edilebilir (likidasyon). Çapraz marjinde bir pozisyonun zararı hesaptaki diğer pozisyonları ve bakiyeyi de etkiler. Fonlama ücretleri, pozisyon açık kaldıkça sonucu değiştirir.',
          ],
        },
        {
          id: 'strategies',
          heading: '3. Stratejilerin kendi riskleri',
          blocks: [
            [
              'DCA botları fiyat düştükçe güvenlik emirleriyle pozisyonu büyütür: düşüş sürerse zarar ve bağlanan sermaye de büyür, işlem uzun süre zararda kalabilir.',
              'Grid botları sert ve tek yönlü bir harekette aralığın dışında kalır; elinizde değer kaybeden varlık kalabilir.',
              'Zarar durdur (stop loss) ve zaman sınırı gibi korumalar her koşulda çalışmayabilir veya beklediğiniz fiyattan gerçekleşmeyebilir.',
              'Hedge ve kurtarma özellikleri zararı her zaman sınırlamaz; ek pozisyon, ek teminat ve ek risk demektir.',
            ],
          ],
        },
        {
          id: 'past',
          heading: '4. Geçmiş sonuçlar ve backtestler garanti değildir',
          blocks: [
            [
              'Geçmiş sonuçlar ve backtestler gelecekteki getirinin garantisi değildir.',
              'Backtestler geçmiş fiyat verileriyle yapılan simülasyonlardır: fiyat kayması, emir defteri derinliği, gecikme ve borsa kesintileri modellenmez; ücret ve fonlama yaklaşıktır.',
              'Çok sayıda ayar denendiğinde bazıları yalnızca şans eseri iyi görünür. Vitrin ve sonuçlar sayfası yalnızca getirisi pozitif olan botları gösterir; bu, platformdaki botların ortalama sonucu değildir.',
              'Yüzde getiriler, aynı anda kullanılan en yüksek sermayeye göre hesaplanır; sizin hesabınızda, sizin tutarlarınızla sonuç farklı olabilir.',
            ],
          ],
        },
        {
          id: 'automation',
          heading: '5. Otopilot ve piyasa tarayıcısı',
          blocks: [
            'Piyasa tarayıcısı ve otopilot kurallara dayalı otomatik seçimler yapar. Bu seçimler yatırım tavsiyesi değildir ve piyasa koşulları değiştiğinde başarısız olabilir. Otopilotu açtığınızda açtığı botlar gerçek parayla, sizin hesabınızda işlem yapar.',
          ],
        },
        {
          id: 'technical',
          heading: '6. Teknik riskler',
          blocks: [
            'Sunucu, internet, borsa API’si ve yazılım hataları nedeniyle emirler gecikebilir, iletilmeyebilir veya iptal edilemeyebilir. Hizmet durduğunda borsada açık olan emirler ve pozisyonlar borsada kalır.',
          ],
        },
        {
          id: 'exchange',
          heading: '7. Borsa riskleri',
          blocks: [
            'Varlıklarınız bağladığınız borsada durur. Borsanın iflası, saldırıya uğraması, hesabınızı dondurması, bir coini listeden çıkarması veya kurallarını değiştirmesi QuantPhi’nin kontrolü dışındadır.',
          ],
        },
        {
          id: 'regulation',
          heading: '8. Mevzuat ve vergi',
          blocks: [
            'Kripto varlıklara ilişkin düzenlemeler ülkeden ülkeye farklıdır ve değişebilir. Bulunduğunuz yerde bu işlemlere izin verilip verilmediğini kontrol etmek ve vergi yükümlülüklerinizi yerine getirmek sizin sorumluluğunuzdadır.',
          ],
        },
        {
          id: 'advice',
          heading: '9. Yatırım tavsiyesi değildir',
          blocks: [
            'QuantPhi bir yazılım aracıdır; yatırım tavsiyesi vermez. Kararlarınızı kendi değerlendirmenizle verin, gerekiyorsa yetkili bir yatırım danışmanından destek alın. Yatırım kararlarınızın ve sonuçlarının sorumluluğu tamamen size aittir. Ayrıntılar {terms:’nda} yer alır.',
          ],
        },
      ],
    },
  },
};
